import { observer } from 'mobx-react-lite'
import React from 'react'
import { ContainerHeader, Divider, FullPageWrapper, SpinnerLoader, Typography } from 'shared/ui'
import { LINK_REFERRALS_PARTNER_PROGRAM_OVERVIEW_GUIDE } from 'shared/constants/links'
import { getCDNAssetURL } from 'shared/lib'
import referralsPreviewBannerImg from 'shared/assets/images/referrals/referrals_preview_banner.png'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useReferralsViewContext } from 'pages/settings/pages/referrals/context/referralsViewContext'
import { ReferralsEmpty } from 'pages/settings/pages/referrals/pages/ReferralsView/ui/ReferralsEmpty/ReferralsEmpty'
import { LearnMoreLink } from 'pages/settings/ui/LearnMoreLink/LearnMoreLink'
import { ReferralsHistory } from 'pages/settings/pages/referrals/pages/ReferralsView/ui/ReferralsHistory/ReferralsHistory'
import { ReferralsLinks } from 'pages/settings/pages/referrals/pages/ReferralsView/ui/ReferralsLinks/ReferralsLinks'
import { ReferralsPayPal } from 'pages/settings/pages/referrals/pages/ReferralsView/ui/ReferralsPayPal/ReferralsPayPal'
import styles from './styles.module.scss'

const REFERRAL_THRESHOLD = 50
const REFERRAL_REWARD = 50
const DIVIDER_MARGINS = { marginTop: '21.5px', marginBottom: '21.5px' }

export const Referrals = observer(() => {
  const { isPageSpinnerShown } = useReferralsViewContext()
  const { usersStore } = useEntitiesContext()

  const isEmptyReferral = !usersStore.user?.hasFirstPromoterRef

  if (isPageSpinnerShown) {
    return <SpinnerLoader ariaLabel={'Referrals'} />
  }

  if (isEmptyReferral) {
    return <ReferralsEmpty />
  }

  return (
    <FullPageWrapper className={styles.container}>
      <div className={styles.content}>
        <ContainerHeader
          customTitle={
            <div className={styles.pageHeader}>
              <Typography variant='heading-lg' ariaLabel='ReferralsPage_title'>
                Referrals
              </Typography>
            </div>
          }
          titleVariant='heading-lg'
          paddingTop={64}
          paddingBottom={24}
          paddingLeft={0}
          paddingRight={0}
          isAutoHeight
        />

        <div className={styles.previewImageContainer} aria-label='ReferralsPage_preview'>
          <img
            alt='Referrals Page Preview'
            src={getCDNAssetURL(referralsPreviewBannerImg)}
            onError={(e) => {
              console.warn('Failed to load referrals preview image')
              e.currentTarget.style.display = 'none'
            }}
          />
        </div>
        <Typography
          variant='body-md-regular'
          color='var(--content-primary-tertiary)'
          ariaLabel='ReferralsPage_desc'
          marginBottom={48}
        >
          Once your referral spends ${REFERRAL_THRESHOLD} with us, you&apos;ll get $
          {REFERRAL_REWARD}. There is no limit to the amount of credit you can earn through
          referrals.
          <LearnMoreLink href={LINK_REFERRALS_PARTNER_PROGRAM_OVERVIEW_GUIDE}>
            Learn more
          </LearnMoreLink>
          .
        </Typography>
        <ReferralsHistory />
        <ReferralsLinks />
        <Divider style={DIVIDER_MARGINS} />
        <ReferralsPayPal />
      </div>
    </FullPageWrapper>
  )
})
